import { IContextClient } from "../types/client.interface";
import { createContext } from "react";

const ClientScreen = createContext<IContextClient>({});

export default ClientScreen;
